/**
 * Tracks which puzzles the solver revealed the answers to.
 *
 * A revealed puzzle is saved with the full solution in the grid but is never
 * flagged complete on the server, so without this the auto-check would see a
 * filled, correct grid on the next visit and record it as a real solve.
 */

const KEY = 'revealedPuzzles';

const read = (): number[] => {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const wasRevealed = (puzzleId: number): boolean =>
  read().includes(puzzleId);

export const markRevealed = (puzzleId: number): void => {
  const revealed = read();
  if (!revealed.includes(puzzleId)) {
    localStorage.setItem(KEY, JSON.stringify([...revealed, puzzleId]));
  }
};

export const clearRevealed = (puzzleId: number): void => {
  localStorage.setItem(
    KEY,
    JSON.stringify(read().filter(id => id !== puzzleId))
  );
};
